import { render, staticRenderFns } from "./RoundGlow.vue?vue&type=template&id=3885250a&scoped=true&lang=pug"
import script from "./RoundGlow.vue?vue&type=script&lang=js"
export * from "./RoundGlow.vue?vue&type=script&lang=js"
import style0 from "./RoundGlow.vue?vue&type=style&index=0&id=3885250a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885250a",
  null
  
)

export default component.exports